import { createContext, useContext, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAuthCode, fetchCheckAuthAPI } from "../redux/slices/authSlice";
import { toast } from "react-toastify";

export const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const authStatus = useSelector((state) => state.auth.status);
  const loading = useSelector((state) => state.auth.loading);
  const navigate = useNavigate();
  const location = useLocation();
  const code = searchParams.get("code");
  const isLoginOAuthPath = location.pathname === "/oauth";
  const refreshAfterToast = () => {
    window.location.reload();
  };

  const callNavigation = (status) => {
    const normalizedStatus = String(status || "").toLowerCase();
    const isAuthorizedStatus =
      normalizedStatus === "authorized" || normalizedStatus === "success";

    if (isAuthorizedStatus) {
      if (
        location.pathname === "/login" ||
        location.pathname === "/oauth" ||
        location.pathname === "/"
      ) {
        navigate("/home");
      }
    } else {
      if (location.pathname === '/onboarding') {
        return;
      }
      navigate("/login");
    }
  };

  useEffect(() => {
    if (!authStatus) {
      return;
    }

    if (isLoginOAuthPath) {
      if (code && !loading) {
        dispatch(fetchAuthCode(code))
          .unwrap()
          .then((res) => {
            const status = String(res?.status || "").toLowerCase();
            const isAuthorized =
              status === "authorized" || status === "success";
            if (!isAuthorized) {
              toast.error(
                "Vergewissere dich, dass du deinen Discord-Account verbunden hast. Versuche es nochmal mit OTP.",
                { autoClose: 5000, onClose: refreshAfterToast }
              );
            } else {
              dispatch(fetchCheckAuthAPI());
            }
            callNavigation(status);
          })
          .catch(() => {
            toast.error(
              "Vergewissere dich, dass du deinen Discord-Account verbunden hast. Versuche es nochmal mit OTP.",
              { autoClose: 5000, onClose: refreshAfterToast }
            );
            callNavigation("unauthorized");
          });
      } else if (!loading && authStatus !== "authorized") {
        dispatch(fetchCheckAuthAPI())
          .unwrap()
          .then((res) => {
            callNavigation(res?.status);
          });
      }
    } else if (!loading && authStatus !== "authorized") {
      dispatch(fetchCheckAuthAPI())
        .unwrap()
        .then((res) => {
          callNavigation(res?.status);
        });
    }
  }, []);

  const value = {};

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
